<template>
  <div class="chat">
    <div class="row">
      <div class="col-12 text-end">
        <button class="btn btn-link" v-on:click="toggleChat" v-if="visible">Cacher le chat</button>
        <button class="btn btn-link" v-on:click="toggleChat" v-else>Montrer le chat</button>
      </div>
      <div class="col-12">
        <ul v-if="visible" ref="messageDisplay">
          <li v-for="message in messages" v-bind:key="message.instant"
            :class="message.admin ? 'admin-message' : ''">
            <span v-if="role === 'admin'"
              v-on:click="deleteMessage(message.id)" class="admin-action">
              <img src="/static/delete.svg" class="icon" width="10"/>
            </span>
            <span class="dateMessage" v-if="showTime">{{convertDate(message.instant)}}</span>
            <span class="dateMessage" v-else>{{convertTime(message.instant)}}</span>
            <span class="author">{{message.author}} &gt;</span>
            {{message.message}}
          </li>
        </ul>
      </div>
    </div>
    <div class="row" v-if="visible">
      <div class="col-12">
        <GameChatInput v-bind:gameId="gameId" v-on:send="send"></GameChatInput>
      </div>
    </div>
  </div>
</template>

<script>
import iam from '../../iam';
import GameChatInput from './GameChatInput.vue';

const padZero = n => ((n < 10) ? `0${n}` : n);

export default {
  name: 'GameChatStomp',
  props: {
    gameId: {
      type: String,
      required: true,
    },
    showTime: {
      type: Boolean,
      required: false,
    },
  },
  components: { GameChatInput },
  data() {
    return {
      messages: [],
      visible: true,
      username: undefined,
      socket: undefined,
      role: iam.getConnectedUser() ? sessionStorage.getItem('userrole') : undefined,
    };
  },
  created() {
    this.username = iam.getConnectedUser().username;
    this.messageList(this.gameId)
      .then((messages) => {
        this.messages = messages.map((m) => {
          const d = JSON.parse(m.data);
          return {
            ...d,
            id: m.id,
          };
        }).sort((a, b) => a.instant - b.instant);
      }).then(() => this.connect());
  },
  updated() {
    const container = this.$refs.messageDisplay;
    if (container) {
      container.scrollTop = container.scrollHeight;
    }
  },
  methods: {
    toggleChat() {
      this.visible = !this.visible;
    },
    connect() {
      this.socket = new WebSocket(`${import.meta.env.VITE_LCT_CHAT_URL}?activeGameId=${this.gameId}`);

      this.socket.onmessage = (event) => {
        const d = JSON.parse(event.data);
        this.messages.push({
          ...d,
          id: event.id,
        });
      };
    },
    convertDate(timestamp) {
      const currentDate = new Date(timestamp);
      const M = padZero(currentDate.getMonth() + 1);
      const d = padZero(currentDate.getDate());
      const h = padZero(currentDate.getHours());
      const m = padZero(currentDate.getMinutes());
      return `${d}/${M} ${h}:${m}`;
    },
    convertTime(timestamp) {
      const currentDate = new Date(timestamp);
      const h = padZero(currentDate.getHours());
      const m = padZero(currentDate.getMinutes());
      return `${h}:${m}`;
    },
    send(message) {
      const d = new Date();
      const payload = { action: 'onMessage',
        data: JSON.stringify({
          message,
          instant: d.getTime(),
          author: this.username,
          admin: this.role === 'admin' }),
        activeGameId: this.gameId };
      if (this.socket) {
        if (this.socket.readyState === WebSocket.CLOSED) {
          this.connect();
          setTimeout(() => this.socket.send(JSON.stringify(payload)), 1000);
        } else {
          this.socket.send(JSON.stringify(payload));
        }
      }
    },
    deleteMessage(messageId) {
      return this.$http.delete(`${import.meta.env.VITE_LCT_API_URL}/chat/${messageId}`)
        .then(() => {
          const index = this.messages.findIndex(m => m.id === messageId);
          this.messages.splice(index, 1);
        });
    },
    messageList(gameId) {
      return this.$http.get(`${import.meta.env.VITE_LCT_API_URL}/chat?activeGameId=${gameId}`)
        .then(response => response.data);
    },
  },
};
</script>

<style scoped>
.chat ul {
    min-height: 300px;
    list-style-type: none;
    margin: 0 0 10px;
    box-shadow: inset 0 1px 1px rgba(0,0,0,.075);
    -webkit-transition: border linear .2s,box-shadow linear .2s;
    transition: border linear .2s,box-shadow linear .2s;
    border: 1px solid #CCC;
    border-radius: 3px;
    -webkit-border-radius: 3px;
    padding: 4px 10px;
    height: 220px;
    max-height: 220px;
    overflow-y: scroll;
}
.chat .dateMessage {
    color: #565656;
}
.chat ul li .author {
    color: #647687;
}
.chat .btn-link{
  font-size: 0.8rem;
}
.admin-action {
  cursor: pointer;
}
.admin-message {
  color: #5050FF;
}
</style>
